import nookies from 'nookies'
import MobileDetect from 'mobile-detect'
import React from 'react'
import Search from 'src/components/Search/Search'
import MobileSearchPage from 'src/components/mobilePages/catalog/MobileSearchPage/MobileSearchPage'
import { allSettled } from 'effector'
import { setPageState } from '@entities/route/model'
import { initSearchGroupGoods, setSearchTerm } from 'src/features/goods-groups-update/model'
import { createGSSP, pageStarted } from 'src/pages/shared/bindings'
import { initShipmentGSSP } from '@entities/shipment/init-gssp'
import { setCurrentGroupId } from '@entities/groups/model'

export default function SearchIndex(props) {
    // eslint-disable-next-line react/prop-types
    if (props.mobile) {
        return <MobileSearchPage />
    }
    return <Search />
}

export const getServerSideProps = createGSSP({
    pageEvent: pageStarted,
    async customize({ scope, context }) {
        const { q } = context.query
        const md = new MobileDetect(context.req.headers['user-agent'])
        const cookies = nookies.get(context)
        const shipmentCookie = cookies['storage-shipment']
        const shipment = shipmentCookie ? JSON.parse(shipmentCookie) : { stockId: 0, cityId: 1 }
        await allSettled(setCurrentGroupId, { scope, params: 0 })
        await initShipmentGSSP(scope, context)
        await allSettled(setPageState, {
            scope,
            params: {
                isCatalogPage: false,
                isSearchPage: true
            }
        })
        await allSettled(setSearchTerm, { scope: scope, params: q })
        await allSettled(initSearchGroupGoods, {
            scope: scope,
            params: { term: q, ctx: context, shipment }
        })
        return {
            props: { mobile: md.mobile() }
        }
    }
})
